module.exports = __webpack_public_path__ + "img/trustwallet.a2a0358d.png";